<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="840"
    >
      <v-card>
        <v-card-text>
            <div id="printer1" class="printer" >
                <h2>PAYMENT RECEIPT</h2>
                <div class="printer_head">
                    <img :src="e_img" alt="">
                    <div class="order_details"> Details For Order :<br> <p>#{{doc.orderid}}</p> </div>
                </div>
                <table class="table1">
                    <tr>
                        <td>Order Date</td>
                        <td>{{new Date(parseInt(doc.date)) | moment("DD-MMM-YYYY")}}</td>
                    </tr>
                    <tr>
                        <td> Order No</td>
                        <td>{{doc.orderid}}</td>
                    </tr>
                    <tr>
                        <td style="font-weight:bold">Order Total</td>
                        <td>{{doc.amount}}</td>
                    </tr>
                </table>
                <div class="bill_details">
                    <h3>ELECTRICITY BILL PAYMENT</h3>
                    <p>Bill Payment Status : </p>
                    <p class="bill_amount"><span style="font-weight:normal">Amount</span>
                    <br>
                        {{doc.amount}}
                     </p>
                     <table class="table2">
                         <tr>
                             <td>CA Number</td>
                             <td>{{doc.phone}}</td>
                         </tr>
                         <tr>
                             <td>Provider</td>
                             <td>{{doc.service}}</td>
                         </tr>
                         <tr>
                             <td>BBPS Reference No.</td>
                             <td>{{doc.reference}}</td>
                         </tr>
                     </table>
                     <div class="payment_message">
                         Thank you for your payment. Your payment will be updated at the biller's end within 2-3 working days.
                         You may download your payment receipt in 2-3 working days. If you have paid your bill before the due date, no late payment fees would be charged to your bill. If you have paid your bill penalty, you could be charged a late payment fees by the biller. Any excess payment made would be adjusted with the next bill due. Partial payments would be liable to late payment fees.
                     </div>
                </div>
                    <div class="bill_details" style="margin-top:10px; height:130px">
                    <h3>PAYMENT INFORMATION</h3>
                    <div class="left">
                        <h4>Payment Channel:</h4>   
                        <span>Online</span>      
                    </div>
                    <div class="right">
                        <table style="width:350px">
                            <tr>
                                <td style="text-align:right">Item(s) Subtotal :</td>
                                <td> {{doc.amount}}</td>
                            </tr>
                            <tr>
                                <td style="text-align:right;font-weight:bold">Grand Total :</td>
                                <td style="font-weight:bold"> {{doc.amount}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            flat="flat"
            @click="$parent.printbill = false"
          >
          Cancel
          </v-btn>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="print"
          >
          Print
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>

export default {
    props: ["doc"],
    data() {
        return {
            dialog: true
        }
    },
    computed: {
        e_img() {
            return this.$store.getters.print_image;
        }
    },
    methods: {
        print() {
            const css = `
                .printer {
                    width: 800px;
                }
                .printer h2 {
                    width: 100%;
                    text-align: center;
                    height: 40px;
                    margin:0px;
                    padding-top: 10px;
                    background: #f0f0f0;
                }
                .printer_head{
                    width: 100%;
                }
                .printer_head img{
                    width: 200px;
                }
                .order_details{
                    float:right;
                    margin-right: 20px;
                    margin-top: 20px;
                    color: #F4982F;
                }
                .order_details p{
                    font-weight: bold;
                }
                .table1{
                    width: 200px;
                }
                .table1 td{
                    padding-left:0px!important;
                }
                .table2 td{
                    height: 20px!important;
                    font-weight: 500!important;
                }
                .table2{
                    margin-left:10px;
                }
                .bill_details{
                    width:100%;
                    height: 300px;
                    border:2px solid lightgray;
                }
                .bill_details h3{
                    width: 100%;
                    text-align: center;
                    height: 30px;
                    margin:0px;
                    padding-top: 10px;
                    background: #f0f0f0;
                    border-bottom: 2px solid lightgray;
                }
                .bill_details p {
                    margin-top: 10px;
                    color: #F4982F;
                    font-size: 15px;
                    padding-left: 10px;
                    width: 50%;
                    height: 50px;
                    float:left;
                    box-sizing: border-box;
                    font-weight: bold;
                    margin-bottom:0px;
                }
                .bill_amount {
                    text-align: right;
                    padding-right: 20px;
                    color: black!important;
                }
                .payment_message{
                    width: 100%;
                    box-sizing: border-box;
                    padding: 10px;
                }
                .left{
                    float: left;
                    padding: 10px;
                }
                .left h4{
                    margin:0px;
                    font-size:18px;
                }
                @media print {
                    body {-webkit-print-color-adjust: exact;}
                }
                .right{
                    float:right;
                }`
                const prtHtml = document.getElementById('printer1').innerHTML;
                const WinPrint = window.open('', '', 'left=0,top=0,width=1000,height=900,toolbar=0,scrollbars=0,status=0');

                WinPrint.document.write(`<!DOCTYPE html>
                <html>
                <head>
                    <style>
                    ${css}
                    </style>
                </head>
                <body>
                    <div class="printer">
                        ${prtHtml}
                    </div>
                </body>
                </html>`);

                WinPrint.document.close();
                WinPrint.focus();
                setTimeout(function () {
                WinPrint.print();
                WinPrint.close();                    
                },500)

        }
    },
    mounted() {
        console.log(this.doc);
    }
}
</script>

<style scoped>
.printer {
    width: 800px;
    display: block;
}
.printer h2 {
    width: 100%;
    text-align: center!important;
    height: 40px;
    padding-top: 5px;
    background: #f0f0f0;
}
.printer_head{
    width: 100%;
}
.printer_head img{
    width: 200px;
}
.order_details{
    float:right;
    margin-right: 20px;
    margin-top: 20px;
    color: #F4982F;
}
.order_details p{
    font-weight: bold;
}
.table1{
    width: 200px;
}
.table1 td{
    padding-left:0px!important;
}
.table2 td{
    height: 20px!important;
    font-weight: 500!important;
}
.bill_details{
    width:100%;
    height: 300px;
    border:2px solid lightgray;
}
.bill_details h3{
    width: 100%;
    text-align: center;
    height: 40px;
    padding-top: 8px;
    background: #f0f0f0;
    border-bottom: 2px solid lightgray;
}
.bill_details p {
    margin-top: 10px;
    color: #F4982F;
    font-size: 15px;
    padding-left: 10px;
    width: 50%;
    height: 50px;
    float:left;
    font-weight: bold;
    margin-bottom:0px;
}
.bill_amount {
    text-align: right;
    padding-right: 20px;
    color: black!important;
}
.payment_message{
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
}
.left{
    float: left;
    padding: 10px;
}
.left h4{
    font-size:18px;
}
.right{
    float:right;
}
</style>